import React from 'react'
import { StyledLink, StyledText } from './styles'

export const LocationDetails = (props) => {
  const original = props.cell.row.original
  const id = original.id
  const displayName = original.displayName
  const jurisdictionName = original.jurisdictionName
  return (
    jurisdictionName ? (
      <StyledLink to={`/minWage/details/${id}`}>
        {displayName}
      </StyledLink>
    )
      : <StyledText>{displayName}</StyledText>)
}

export default LocationDetails
